import { parseISO, differenceInMinutes, isValid } from "date-fns";

// Função para verificar se a data SLA foi ultrapassada
export const isSLAPassed = (slaDate) => {
  if (!slaDate || !isValid(parseISO(slaDate))) return false; // Verifica se slaDate é válido
  const differenceMinutes = differenceInMinutes(new Date(), parseISO(slaDate));
  // console.log('DIFF: '+differenceHours)
  return differenceMinutes >= 0; // Retorna true se já passou do SLA
};

// Função para verificar se faltam menos de 3 horas para o SLA
export const isSLANear = (slaDate) => {
  if (!slaDate || !isValid(parseISO(slaDate))) return false; // Verifica se slaDate é válido
  const differenceMinutes = differenceInMinutes(parseISO(slaDate), new Date());
  // console.log('slaDate: '+slaDate)
  // console.log('new Date(): '+new Date())
  // console.log('DIFF: '+differenceHours)
  return differenceMinutes < 180 && differenceMinutes >= 120; // Retorna true se faltam menos de 3 horas
};

// Função para verificar se faltam menos de 2 horas para o SLA
export const isSLATwoHour = (slaDate) => {
  if (!slaDate || !isValid(parseISO(slaDate))) return false; // Verifica se slaDate é válido
  const differenceMinutes = differenceInMinutes(parseISO(slaDate), new Date());
  // console.log('slaDate: '+slaDate)
  // console.log('new Date(): '+new Date())
  // console.log('DIFF: '+differenceHours)
  // console.log(differenceMinutes)
  return differenceMinutes < 120 && differenceMinutes > 0; // Retorna true se faltam menos de 2 horas
};


const SLACalcs = {
  isSLAPassed,
  isSLANear,
  isSLATwoHour,
};

export default SLACalcs;
